/* sb-dc-tplnames.js — tidy the names that come off templates.

   Two separate jobs, both about names the customer reads.

   1. LAYER names. The 27 template SVGs sitting in Supabase storage were
      exported back when the app was Korean, and each element carries
      data-dc-name="후보 이름". svgToLayers reads that attribute verbatim, so
      applying one of those templates put Korean into the Layers list and the
      preflight results even though every other string is English. The visible
      artwork text was already English — only the names were stale.

   2. TEMPLATE names. Cards read "VOTE Classic (2:1)", "Profile (Vertical)" —
      the ratio in brackets is production shorthand, not something a customer
      needs. The stored ones were renamed in the database; the ones built into
      the augment bundle are stripped here so both lists match.

   Fixed here rather than in the augment bundle so the 322KB file does not
   have to be re-uploaded by hand.

   The layer pass runs as a watcher instead of hooking one code path, because
   a template can arrive three ways: the Templates panel, a ?tpl= deep link
   from the Design Templates page, and the size-change refit. All three end up
   in the document, so watching the document catches all of them.

   The key list was read out of the stored SVGs and the escapes generated from
   those exact strings — hand-typing them got \ub744 (뜼) where the file has
   \ub760 (띠), and two layers silently kept their Korean names. */
(function () {
  'use strict';

  /* ---------------------------------------------------------- layer names */
  var MAP = {
    '고지 문구': 'Notice text',
    '구분선': 'Divider',
    '금색 테두리': 'Gold border',
    '날짜': 'Date',
    '문구': 'Text',
    '바깥 링': 'Outer ring',
    '바탕': 'Background',
    '별': 'Star',
    '빨간 테두리': 'Red border',
    '세로선': 'Vertical line',
    '아랫 띠': 'Bottom bar',
    '안내': 'Info',
    '연도': 'Year',
    '오른쪽 별': 'Right star',
    '왼쪽 별': 'Left star',
    '윗 띠': 'Top bar',
    '이름 1줄': 'Name line 1',
    '이름 2줄': 'Name line 2',
    '제목': 'Heading',
    '직책': 'Title',
    '직책 · 날짜': 'Title · Date',
    '체크': 'Check',
    '테두리': 'Border',
    '후보 이름': 'Candidate name'
  };
  var HANGUL = /[\uAC00-\uD7A3]/;

  /* Unmapped names keep their Korean rather than getting a generic label —
     a wrong name is worse than a foreign one, and this list came from reading
     every stored SVG, so a miss means a template we have not seen. */
  function rename(name) {
    if (!name || !HANGUL.test(name)) return null;
    var k = String(name).trim();
    if (k.normalize) k = k.normalize('NFC');       // stored files may be decomposed
    return MAP[k] || null;
  }

  function pass() {
    var api = window.__dcApi;
    if (!api || !api.doc || !Array.isArray(api.doc.layers)) return;
    var layers = api.doc.layers, changed = false;
    var next = layers.map(function (l) {
      var to = rename(l && l.name);
      if (!to) return l;
      changed = true;
      var o = {};
      for (var k in l) o[k] = l[k];
      o.name = to;
      return o;
    });
    if (!changed) return;
    try {
      // false = do not add an undo step; renaming is not the customer's edit
      api.setDoc({ layers: next }, false);
    } catch (e) {}
  }

  var timer = setInterval(function () { try { pass(); } catch (e) {} }, 700);
  window.addEventListener('pagehide', function () { clearInterval(timer); });
  window.__dcTplRename = rename;                 // test hook

  /* ------------------------------------------------------- template names */
  /* Only a trailing bracket is dropped, so a name that needs brackets in the
     middle keeps them. Nothing is stripped if it would leave the card blank. */
  var TRAILING = /\s*\([^()]*\)\s*$/;
  function tidy(name) {
    var s = String(name == null ? '' : name);
    var out = s.replace(TRAILING, '').trim();
    return out || s;
  }
  window.__dcTidyTplName = tidy;                 // test hook

  var prevList = window.__dcTemplateList;
  if (typeof prevList === 'function') {
    window.__dcTemplateList = function (base) {
      var list = prevList.apply(this, arguments) || [];
      try {
        list.forEach(function (t) {
          if (!t || t.__dcTidied) return;
          t.name = tidy(t.name);
          t.__dcTidied = true;                   // template objects are reused per render
        });
      } catch (e) {}
      return list;
    };
  }
})();
